import TipoFinanciamientoService from "@/api/services/cobranza/nomencladores/TipoFinanciamientoService"
import Vue from "vue"

const state = () => ({
    financiamientos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "tipo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    FINANCIAMIENTOS: state => {
        return state.financiamientos
    },
    FINANCIAMIENTOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_FINANCIAMIENTOS: (state, payload) => {
        state.financiamientos = payload
    },

    SET_FINANCIAMIENTOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_FINANCIAMIENTO: (state, payload) => {
        state.financiamientos.push(payload)
    },

    UPDATE_FINANCIAMIENTO: (state, payload) => {
        state.financiamientos = state.financiamientos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_FINANCIAMIENTO: (state, payload) => {
        state.financiamientos = state.financiamientos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_FINANCIAMIENTOS: async ({ commit, state }, { filter, financiamientoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoFinanciamientoService.get({
                filter,
                financiamientoEstado,
                ...pagination
            })
            if (status === 200) {
                commit("SET_FINANCIAMIENTOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de financiamientos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_FINANCIAMIENTOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoFinanciamientoService.getAll()
            if (status === 200) {
                commit("SET_FINANCIAMIENTOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_FINANCIAMIENTOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoFinanciamientoService.getAllRecords()
            if (status === 200) {
                commit("SET_FINANCIAMIENTOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de financiamientos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_FINANCIAMIENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoFinanciamientoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_FINANCIAMIENTO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del tipo de financiamiento, inténtelo nuevamente"
            })
        }
    },

    ADD_FINANCIAMIENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoFinanciamientoService.post(payload)
            if (status === 201) {
                commit("ADD_FINANCIAMIENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo de financiamiento ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo de financiamiento, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_FINANCIAMIENTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoFinanciamientoService.put(payload)
            if (status === 200) {
                commit("UPDATE_FINANCIAMIENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de financiamiento ha sido modififcado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo de financiamiento, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_FINANCIAMIENTO: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoFinanciamientoService.delete(payload)
            if (status === 204) {
                commit("DELETE_FINANCIAMIENTO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de financiamiento ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_FINANCIAMIENTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de financiamiento ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de financiamiento, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
